import React, {useState, useEffect, useRef, useMemo} from 'react'

import classes from './ImageTarget.module.css'
import Target from '../Target/Target';
import Draggable from '../Draggable/Draggable';
import { observer } from 'mobx-react-lite';

const ImageTarget = ({dd, step, corrects}) => {
  const imgRef = useRef(null)
  const [imgSize, setImgSize] = useState(null);

  function handleImageSize() {

    // NOTE on veut placer l'image à la taille max et au centre, et enregistrer les scales/offsets
    // NOTE je ne le fais pas en CSS avec object-fit car je ne peux pas récupérer ces infos ultérieurement, l'élément image fait 100% de son parent

    let i = imgRef.current
    let p = i.parentElement

    let imageRatio = i.naturalWidth / i.naturalHeight
    let parentRatio = p.offsetWidth / p.offsetHeight

    const fullwidth = imageRatio > parentRatio // l'image touche à gauche et droite

    if(fullwidth) {
      const w = p.offsetWidth
      const h = w / imageRatio
      const x = 0
      const y = (p.offsetHeight - h) / 2
      const scale = w / i.naturalWidth
      const parentHeight = p.offsetHeight

      setImgSize({w, h, x, y, scale, parentHeight})

    }
    else {
      const h = p.offsetHeight
      const w = h * imageRatio
      const x = (p.offsetWidth - w) / 2
      const y = 0
      const scale = w / i.naturalWidth

      const parentHeight = p.offsetHeight
      setImgSize({w, h, x, y, scale, parentHeight})
    }
  }

  const imgstyle = useMemo(() => {
    console.log("processing imgstyle")
    const imgstyle = {}
    if(imgSize) {
      imgstyle.width = imgSize.w
      imgstyle.height = imgSize.h
      imgstyle.marginLeft = imgSize.x
      imgstyle.marginTop = imgSize.y,
      imgstyle["--scale"] = imgSize.scale
    }
    return imgstyle
  }, [imgSize])

  const imgCtnrStyle = {}
  if(imgSize) {
    imgCtnrStyle.height = imgSize.parentHeight
  }
  return (
    <div className={classes.ImageTarget}>
      <img
      style={imgstyle}
      ref={imgRef}
      // onLoad={handleImageSize}
      src={dd.media} />

      {/* {imgstyle && */}
      <div className={classes.targets}>
        {dd.targets.map(t => {
          let x = t.x || 30
          let y = t.y || 30
          // let width = target.width || 250


          let style={
            "--mx": 0, //imgstyle.marginLeft + "px" ,
            "--my": 0, //imgstyle.marginTop + "px" ,
            "left": x+"%",
            "top": y+"%",

            // "--width": width + "px"
          }


          return (
          <div style={style} className={classes.target} key={t.ID}>
            <Target target={t}  >
            {(step === 0 || step === 1) &&
            dd.getSortedPlacedPropositionsByTarget(t)
            .map(i => (
              <Draggable
                key={i.ID}
                item={i}
                inTarget={t.ID}
                showCorrection={step === 1 || corrects.includes(i.ID)}
                disabled={corrects.includes(i.ID)}
              />
            ))}

            {step === 2 &&
            dd.getSortedPropositionsByTarget(t)
            .map(i => (
              <Draggable
                key={i.ID}
                item={i}
                inTarget={t.ID}
                showCorrection={true}
                disabled={true}
              />

            ))}
            </Target>

          </div>)
        })}
      </div>
      {/* } */}
    </div>
  );
};

export default observer(ImageTarget);
